<div class="map-container">
    @defer (when ccAccepted$()) {
    <iframe
        [src]="mapUrl"
        width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
    </iframe>
    } @placeholder {
    <div class="custom-title-medium">Karte wird geladen...</div>
    }
</div>
